import React, { useState } from "react";
import Speaker from "../components/Speaker";

const SpeakerPage = () => {
  return (
    <div className="min-h-screen flex flex-col bg-gray-50">
      <main>
        <Speaker />
      </main>
    </div>
  );
};

export default SpeakerPage;
